module.exports = __webpack_public_path__ + "static/47434547_2198759903491047_8740383323534131200_o_optimized-ab8f33e4c492f85fd0cc888aececeb95.jpg";